export default "__VITE_ASSET__CtrziyAw__"